<template>
  <div class="w-full px-4 mt-5 centrarElemento">
    <div class="mt-10 lg:mt-0">
    <span class="mb-4 block text-lg font-semibold text-primary-500">
        Este es un sitio de pruebas
    </span>
    <h2 class="mb-5 text-3xl font-bold text-neutral-700 sm:text-[40px]/[48px]">
        Aquí se encuentra el listado de tareas pendientes.
    </h2>
    <p class="mb-5 text-base text-neutral-500">
        Cuando se realice la correcta conexión con el modelo de negocio del sistema y la base de datos, aquí se encontrará la lista de tareas pendientes, y se podrá asignar su estado.
    </p>
    <p class="mb-8 text-base text-neutral-500">
        Este mensaje solo se visualizará en el modelo de ejemplo del sitio.
    </p>
</div>

            </div>
  <div class="list_wrapper">
    <ul role="list" class="divide-y divide-gray-100">
      <li v-for="tasks in data" :key="tasks.id" class="flex justify-between gap-x-6 py-5">
        <div class="flex min-w-0 gap-x-4">
          <img class="h-12 w-12 flex-none rounded-full bg-gray-50" src="/img/logo.png" alt="" />
          <div class="">
            <p class="text-sm font-semibold leading-6 text-gray-900">{{ tasks.title }}</p>
            <a :href="`http://localhost:8080/taskinfo/${tasks.id}`" class="mt-1 text-xs leading-5 text-gray-500">Ver detalles</a>
          </div>
        </div>
        <div class="">
          <p class="containerStatus text-sm truncate leading-6 text-gray-900" :style="getStatusStyle(tasks.status)">{{
        tasks.status }}</p>
          <p class="text-sm leading-6 text-gray-900">{{ tasks.assigned_user.name }}</p>
          
        </div>
      </li>
    </ul>
  </div>

</template>
<script>

export default {
  data() {
    return {
      data: '',
      items: [
        { status: 'En proceso' },
        { status: 'Pendiente' },
        { status: 'Completado' },
        { status: 'Bloqueado' }
      ]
    };
  },
  methods: {
    getStatusStyle(status) {
      switch (status) {
        case 'En proceso':
          return { backgroundColor: 'yellow' };
        case 'Pendiente':
          return { backgroundColor: 'orange' };
        case 'Completado':
          return { backgroundColor: 'lightgreen' };
        case 'Bloqueado':
          return { backgroundColor: 'red' };
        default:
          return { backgroundColor: 'white' }; // Color por defecto si el estado no coincide con ninguno de los anteriores
      }
    }
  },


  async created() {
    
    try {
      const response = await fetch('http://127.0.0.1:8000/api/tasks');
      const data = await response.json();
      this.data = data;
      console.log(data);
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  }

}
</script>